module.exports = __webpack_public_path__ + "img/薏苡仁.8a5f251e.jpg";